/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.contentstaging.rpc.ContentStagingRevisionsRpc
 */

export const getRevisionsRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingRevisionsRpc',
  rpcName: 'getRevisions',
  auth: 'app',
  fingerprint: 'PWmoqDgN2yMSpGEs3nhrGN4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getRevisionRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingRevisionsRpc',
  rpcName: 'getRevision',
  auth: 'app',
  fingerprint: '59vo5yOlkeM1jD6NT9nr194p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const restoreRevisionRpc = {
  serviceName: 'com.hubspot.contentstaging.rpc.ContentStagingRevisionsRpc',
  rpcName: 'restoreRevision',
  auth: 'app',
  fingerprint: 'KP29qzoQgq3iwNa0k3BzPd4p8Cd9Hs1J',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};